import { render, staticRenderFns } from "./dragVerify.vue?vue&type=template&id=22138492&scoped=true"
import script from "./dragVerify.vue?vue&type=script&lang=js"
export * from "./dragVerify.vue?vue&type=script&lang=js"
import style0 from "./dragVerify.vue?vue&type=style&index=0&id=22138492&prod&scoped=true&lang=css"
import style1 from "./dragVerify.vue?vue&type=style&index=1&id=22138492&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22138492",
  null
  
)

export default component.exports